import React, { forwardRef } from 'react'

import { Link as RebassLink, LinkProps } from 'rebass'
import RouterLink, { LinkProps as RouterLinkProps } from 'next/link'

export interface SLinkProps extends Omit<LinkProps, 'as' | 'href'> {
    href:
        | string
        | {
              pathname: string
              query: { [key: string]: string }
          }
    external?: boolean
    shallow?: boolean
    as?: LinkProps['as'] | RouterLinkProps['as']
}

const SLink = forwardRef<any, SLinkProps>((props: SLinkProps, ref) => {
    // forwardRef  don't play nice with eslint
    // eslint-disable-next-line
    const { href, as = undefined, shallow = false, external = false, sx = {}, ...otherProps } = props
    const linkProps: any = {
        sx: {
            textDecoration: 'none',
            cursor: 'pointer',
            // '&:visited': {
            //     color: 'inherit',
            // },
            ...sx,
        },
        ...otherProps,
    }

    const asProps = as !== undefined ? { as: as as string } : {}

    if (external) {
        linkProps.href = href
        return <RebassLink ref={ref} {...linkProps} {...asProps} />
    } else {
        return (
            <RouterLink href={href} {...asProps} passHref shallow={shallow}>
                <RebassLink {...linkProps} ref={ref} />
            </RouterLink>
        )
    }
})

SLink.displayName = 'SLink'

export default SLink
